<template>
    <div>
        <v-row style="margin-top: 150px;" class="justify-center">
            <strong class="success--text">Agora falta pouco!</strong>
        </v-row>
        <v-row class="justify-center py-4">
            <span class="primary--text">A World fará uma rápida análise e em breve seu acesso será liberado.</span>
        </v-row>
        <v-row class="justify-center">
            <span class="primary--text">Obrigado pelo seu cadastro.</span>
        </v-row>
    </div>
</template>

<script>
export default {
    name: 'em-analise'
}
</script>
